<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row">
  <div class="col-md-12">
    <fieldset *ngIf="isWorldPay()">
      <legend class="row">
        <div class="col-md-6 m-auto">eStatement Options</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="!editable"
            (click)="setEditable(true)"
          >
            <span
              *ngIf="isStatementDefined() && isMerchantActive(); else adIcon"
            >
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            {{
              isStatementDefined() && isMerchantActive()
                ? "Edit Statement Options"
                : "Add Statement Options"
            }}
            <ng-template #adIcon>
              <span>
                <fa-icon [icon]="faPlus"></fa-icon>
              </span>
            </ng-template>
          </button>
        </div>
      </legend>

      <div *ngIf="!editable">
        <div class="mt-3">
          <div *ngIf="!isStatementDefined()">
            <div class="col-md-12">
              <span class="row recordRow">
                eStatement Options have not been added.
              </span>
            </div>
          </div>

          <div *ngIf="isStatementDefined()" class="row">
            <div class="col-md-6">
              <div class="table-block">
                <div class="recordRow">
                  <div class="recordLabel">Merchant Tagline</div>
                  <div id="merchantTagLine" class="recordValue">
                    {{
                      merchant.statementOptions[
                        statementOptions.merchantTagLine
                      ]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Statement Logo Name</div>
                  <div id="merchantLogoFilename" class="recordValue">
                    {{
                      merchant.statementOptions[
                        statementOptions.merchantLogoFileName
                      ]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Pay By Phone Number</div>
                  <div id="payOrBillByPhoneNumber" class="recordValue">
                    {{
                      merchant.statementOptions[statementOptions.payByPhoneNo]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Pay By Phone Hours</div>
                  <div id="payOrBillByPhoneHours" class="recordValue">
                    {{
                      merchant.statementOptions[
                        statementOptions.payByPhoneHours
                      ]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Bill Query Phone Number</div>
                  <div id="payOrBillBillQueryNumber" class="recordValue">
                    {{
                      merchant.statementOptions[
                        statementOptions.payQueryPhoneNumber
                      ]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Bill Query Hours</div>
                  <div id="payOrBillBillQueryHours" class="recordValue">
                    {{
                      merchant.statementOptions[statementOptions.billQueryHours]
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">
                    Days between Statement Date and Due Date
                  </div>
                  <div id="stmtDueDateLeadDays" class="recordValue">
                    {{
                      merchant.statementOptions[
                        statementOptions.statementDueDateLeadDays
                      ]
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <img
                id="merchantLogo"
                class="float-right"
                [src]="logoImage"
                alt="Merchant Logo"
              />
            </div>
          </div>
        </div>

        <legend *ngIf="isStatementDefined()" class="borderDivide"></legend>

        <div class="row mt-4" *ngIf="isStatementDefined()">
          <div class="col-md-6">
            <div class="table-block">
              <div class="recordRow">
                <div class="recordLabel">Enable Statement Test Mode</div>
                <div class="recordValue">
                  <input
                    id="statementTestMode"
                    name="statementTestMode"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.statementTestMode
                        ]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Display Aging Boxes</div>
                <div class="recordValue">
                  <input
                    id="detailsAgingBoxes"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.displayAgingBoxes
                        ]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Display Insurance Aging Boxes</div>
                <div class="recordValue">
                  <input
                    id="detailsInsuranceAgingBoxes"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.displayInsuranceAgingBoxes
                        ]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Display Detach Return By Mail</div>
                <div class="recordValue">
                  <input
                    id="detailsDetachReturnByMail"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.displayDetachReturnMail
                        ]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Display Details</div>
                <div class="recordValue">
                  <input
                    id="detailsStatementDetail"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.displayDetails
                        ]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Display Merchant Name</div>
                <div class="recordValue">
                  <input
                    id="detailsMerchantName"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.displayMerchantName
                        ]
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="table-block">
              <div class="recordRow">
                <div class="recordLabel">Pay By Check</div>
                <div class="recordValue">
                  <input
                    id="payOrBillByCheck"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[statementOptions.payByCheck]
                      )
                    "
                  />
                </div>
              </div>

              <div class="recordRow">
                <div class="recordLabel">Pay By Money Order</div>
                <div class="recordValue">
                  <input
                    id="payOrBillByMoneyOrder"
                    type="checkbox"
                    [disabled]="true"
                    [checked]="
                      convertStringToBoolean(
                        merchant.statementOptions[
                          statementOptions.payByMoneyOrder
                        ]
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="editable" class="mt-3">
        <form
          name="generalInfoFormControl"
          (submit)="saveStatementOptions()"
          class="form-horizontal"
          novalidate
          [formGroup]="eStatementForm"
        >
          <app-edit-e-statement-opitons
            [merchant]="merchant"
            [parentGroup]="eStatementForm"
            [logoImage]="logoImage"
          ></app-edit-e-statement-opitons>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="eStatementForm.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
